export interface MenuItemConfig {
    key: string
    /** i18n key passed to translate() */
    labelKey: string
    path: string
    /** Hide menu for these 2-letter country codes. */
    isNotShow?: string[]
}

export const MENU_ITEMS: MenuItemConfig[] = [
    { key: 'invite', labelKey: 'invite', path: '/user/invite' },
    { key: 'subscriptions', labelKey: 'subscriptions', path: '/user/subscriptions', isNotShow: ['OM'] },
    { key: 'orderhistory', labelKey: 'order_history', path: '/user/orderhistory' },
    { key: 'payment-methods', labelKey: 'payment_methods', path: '/user/payment-methods', isNotShow: ['OM'] },
    { key: 'settings', labelKey: 'settings', path: '/user/settings' }
]

export const filterMenu = (items: MenuItemConfig[], options: { country2: string; userStatus: string | null }): MenuItemConfig[] => {
    return items.filter(item => {
        if (item.key === 'invite' && (options.userStatus === 'H' || options.userStatus === 'C')) return false
        if (item.isNotShow?.includes(options.country2)) return false
        return true
    })
}

export const findActiveMenu = (items: MenuItemConfig[], pathname: string): MenuItemConfig | undefined => {
    const normalizedPathname = pathname.replace('/order-history', '/orderhistory')
    return items.find(m => normalizedPathname.startsWith(m.path))
}
